<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="100"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-overlay :value="overlayF">
      <v-progress-circular
        indeterminate
        size="100"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <v-row justify="center" v-show="!overlay">
      <v-col cols="12" lg="10">
        <v-card class="mx-auto">
          <v-list-item three-line>
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="10" lg="12" class="text-center">
                  <img
                    class="responsive"
                    src="../../assets/log.png"
                    alt="Logo telemon"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters align="center">
                <v-col cols="12" lg="2" md="2" sm="2" xl="2">
                  <v-avatar size="90" class="ml-6">
                    <v-img :src="user.url === '' ? img : user.url" alt="perfil">
                      <v-icon
                        @click="pickFile"
                        class="perfil"
                        size="30"
                        color="blue"
                        right
                        >photo_camera</v-icon
                      >
                    </v-img>
                  </v-avatar>

                  <input
                    type="file"
                    style="display:none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </v-col>
                <v-col cols="12" lg="5" md="4" sm="4" xl="5">
                  <p>Titular</p>
                  <p class="font-weight-bold">{{ userModel.nombre_cli }}</p>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="5"
                  sm="4"
                  xl="4"
                  class="text-lg-right"
                >
                  <span class="title font-weight-bold">
                    Estado servicio:
                    <label class="state">{{ userModel.estado }}</label>
                  </span>
                </v-col>
                <v-col cols="12" lg="12" sm="12" md="12" xl="12" class="mt-3">
                  <hr />
                </v-col>

                <v-col
                  cols="10"
                  lg="4"
                  md="4"
                  sm="4"
                  xl="4"
                  class="mt-4 d-inline-block text-truncate"
                >
                  <p class="font-weight-medium">{{ userModel.direccion }}</p>
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                  md="3"
                  sm="3"
                  xl="3"
                  class="mt-4 text-lg-right"
                >
                  <p class="title font-weight-medium">{{ userModel.cedula }}</p>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  xl="4"
                  class="text-lg-right"
                >
                  <span class="title font-weight-medium">
                    Codigo de cliente:
                    <label class="codecolor">{{ userModel.codigo_cli }}</label>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  xl="4"
                  class="mt-3 text-left"
                >
                  <img height="20px" src="../../assets/internet.png" />
                  <span class="title font-weight-medium">
                    Internet:
                    <label
                      :style="[
                        userModel.internet != 'A'
                          ? { color: 'red' }
                          : { color: 'green' },
                      ]"
                    >
                      {{
                        userModel.internet === ""
                          ? "No tiene"
                          : userModel.internet != "A"
                          ? "Suspendido"
                          : "Activo"
                      }}
                    </label>
                  </span>
                </v-col>

                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  xl="4"
                  class="mt-4 text-left"
                >
                  <img height="20px" src="../../assets/cable.png" />
                  <span class="title font-weight-medium">
                    Telecable:
                    <label
                      :style="[
                        userModel.estadocable != 'A'
                          ? { color: 'red' }
                          : { color: 'green' },
                      ]"
                    >
                      {{
                        userModel.estadocable === ""
                          ? "No tiene"
                          : userModel.estadocable != "A"
                          ? "Suspendido"
                          : "Activo"
                      }}
                    </label>
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                  md="4"
                  sm="4"
                  xl="4"
                  class="mt-3 text-left"
                >
                  <img height="20px" src="../../assets/cuota.png" />
                  <span class="title font-weight-medium">
                    Mensualidad:
                    <label class="code">RD$: {{ userModel.cuota }}</label>
                  </span>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <v-btn @click="Exit()" class="ma-2" tile outlined color="error"
              >Cerrar Sesión</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- card sobre plan -->
      <v-col cols="12" lg="2" md="112">
        <v-card
          v-for="(item, index) in userModel.servicios"
          :key="index"
          class="mx-auto mt-2"
          height="140"
        >
          <v-card-text class="text-center">
            <span class="title text--primary text-center">
              {{ item.servicio }}
            </span>
            <br />

            <span class="codecolor">{{ item.paquete }}</span>
            <br />
            <span class="text-center" color="brown">Serie</span>
            <br />
            <span>{{ item.serie }}</span>
          </v-card-text>
        </v-card>
        <!-- nuevo card -->
        <v-card class="mx-auto mt-2 text-center" color="#0d47a1" height="140">
          <v-icon class="mt-3" color="white">sentiment_satisfied_alt</v-icon>
          <v-row justify="center">
            <br />
            <span class="colorCard">!Recuerda¡</span>
          </v-row>

          <div class="containerC">Fecha de pago días 30</div>

          <label class="colorCard"
            >Favor pagar antes del día 5 de cada mes</label
          >
        </v-card>
      </v-col>
      <v-col cols="12" lg="10">
        <p class="display-1">Balance</p>
        <div>
          <v-row>
            <v-col cols="12" lg="4" md="4" sm="4" xl="4">
              <v-card class="mx-auto" width="230">
                <span class="cardtitle font-weight-medium"
                  >Cuota Telecable</span
                >

                <v-card-subtitle class="text-center headline code">
                  <label class="code">RD${{ userModel.cuotacable }}</label>
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="4" xl="4">
              <v-card class="mx-auto" width="230">
                <span class="cardtitle font-weight-medium">Cuota Internet</span>
                <v-card-subtitle class="headline text-center">
                  <label class="code">RD${{ userModel.cuotadatos }}</label>
                </v-card-subtitle>
              </v-card>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="4" xl="4">
              <v-card class="mx-auto" width="230">
                <span class="cardtitle font-weight-medium">Balance total</span>

                <v-card-subtitle class="headline text-center">
                  <label class="code">RD${{ userModel.cuota }}</label>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" lg="10">
        <span class="display-1">Mis facturas</span>
      </v-col>
      <v-col cols="12" lg="10">
        <v-card class="mx-auto">
          <v-list-item three-line>
            <v-list-item-content>
              <v-row align="center" justify="center">
                <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                  <v-btn
                    text
                    :retain-focus-on-click="true"
                    v-on:click="getPeding()"
                    color="error"
                    class="buttonf title font-weight-medium"
                    >Pendientes</v-btn
                  >
                  <hr color="error" />
                </v-col>

                <span class="vl hidden-sm-and-down"></span>

                <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                  <v-btn
                    text
                    :retain-focus-on-click="true"
                    v-on:click="getPaid()"
                    color="green"
                    class="buttonf title font-weight-medium"
                    >Pagadas</v-btn
                  >

                  <hr color="green" />
                </v-col>
                <v-col cols="12">
                  <span class="headline font-weight-regular">
                    Total de facturas:
                    <label>{{ isPaid ? paids.length : pedings.length }}</label>
                  </span>
                </v-col>
                <v-col
                  cols="10"
                  v-for="(item, index) in isPaid
                    ? paginate(paids)
                    : paginate(pedings)"
                  :key="index"
                >
                  <v-card class="mx-auto" color="#ECF1F7">
                    <hr class="v" :color="colorLine" />
                    <v-list two-line subheader>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-row>
                              <v-col cols="12" lg="8" md="8" sm="8" xl="8">
                                <span class="ml-5">{{ item.referencia }}</span>
                              </v-col>
                              <v-col cols="12" lg="4" md="4" sm="4" xl="4">
                                <span class="ml-5 font-weight-light">{{
                                  item.fecha | date
                                }}</span>
                                <br />
                                <span class="headline ml-5"
                                  >RD $ {{ item.valor }}</span
                                >
                              </v-col>
                              <v-col cols="12" lg="4" md="4" sm="4" xl="4">
                                <span
                                  class="ml-5"
                                  :style="[
                                    isPaid
                                      ? { color: 'green' }
                                      : { color: 'red' },
                                  ]"
                                  >{{ isPaid ? "Pagada" : "Pendiente" }}</span
                                >
                              </v-col>
                              <v-col cols="12" lg="4" md="4" sm="4" xl="4">
                                <span class="ml-5 code"
                                  >NO.{{ item.numero_fac }}</span
                                >
                              </v-col>
                              <v-col cols="12" lg="4" md="4" sm="4" xl="4">
                                <span class="ml-5"
                                  >Detalle: {{ item.referencia }}</span
                                >
                              </v-col>
                            </v-row>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            @input="setPage"
            v-model="currentPage"
            circle
            :length="Math.ceil(totalItems / itemsPerPage)"
            :page="currentPage"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="showResult" :timeout="2000" top>
      {{ result }}
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="306">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>

        <v-card-text class="subtitle-1 font-weight-medium">{{
          message
        }}</v-card-text>

        <v-card-actions>
          <v-progress-circular
            v-show="loadingPhoto"
            indeterminate
            size="30"
            color="primary"
          ></v-progress-circular>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="closedDialog()">No</v-btn>

          <v-btn color="green darken-1" text @click="uploadImagePerfil()"
            >Si</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<
<script>
import { mapState, mapActions } from "vuex";
import { formatDate, formatPhone } from "../../filters";
const axios = require("axios");
export default {
  filters: {
    date(timestamp) {
      return formatDate(timestamp);
    },
  },

  data: () => ({
    userModel: {
      nombre_cli: "",
    },
    loadingPhoto: false,
    items2: [],
    img: require("../../assets/sinPerfil.png"),
    showResult: false,
    result: "",
    isPaid: true,
    paids: [],
    pedings: [],
    order: 1,
    overlay: false,
    overlayF: false,
    currentPage: 1,
    itemsPerPage: 4,
    totalItems: 0,
    resultCount: 0,
    colorLine: "green",
    photo: "",
    title: "",
    dialog: false,
    message: "",
    imageName: "",
    imageFile: "",
    imageUrl: "",
  }),
  mounted() {
    this.validateUser();
    this.GetInfoUser();
    this.getPeding();
  },
  computed: {
    ...mapState({ user: "user" }),
    totalPages: function() {
      console.log(
        Math.ceil(this.resultCount / this.itemsPerPage) + "totalPages"
      );
      return Math.ceil(this.resultCount / this.itemsPerPage);
    },
  },
  methods: {
    ...mapActions(["singOutAction", "uploadImage", "updateUser"]),
    Exit() {
      this.singOutAction();
      this.$router.replace("/");
    },
    GetInfoUser() {
      this.overlay = true;
      axios
        .get(
          `https://sistema.telemontv.com:7332/api/publico/clienteporcedula/${this.user.identificationCard}`
        )
        .then((response) => {
          console.log(response.data);
          this.userModel = response.data;
        })
        .catch((e) => {
          error();
          this.overlay = false;
        });
    },
    closedDialog() {
      this.dialog = false;
      this.photo = "";
      this.loadingPhoto = false;
    },
    async uploadImagePerfil() {
      try {
        this.loadingPhoto = true;
        const response = await this.uploadImage({ obj: this.imageFile });
        this.user.url = response;
        const reponse = await this.updateUser(this.user);
        this.closedDialog();
      } catch (e) {
        console.log(e);
        this.$emit("show-snackbar", "Error al guardar la imagen.");
        this.loadingPhoto = false;
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.photo = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
        console.log(this.imageFile);
        console.log(this.photo);
        this.dialog = true;
        (this.title = "Info"),
          (this.message = "Esta seguro de poner esta imagen de perfil?");
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    getPaid() {
      this.colorLine = "green";
      this.isPaid = true;
      this.overlayF = true;
      axios
        .get(
          `https://sistema.telemontv.com:7332/api/publico/ObtenerFacturasSaldaPorCedula/${this.user.identificationCard}`
        )
        .then((response) => {
          this.paids = response.data;
          this.totalItems = this.paids.length;
          this.overlayF = false;
        })
        .catch((e) => {
          error();
          this.overlayF = false;
        });
    },
    paginate: function(list) {
      this.resultCount = list.length;

      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = this.currentPage * this.itemsPerPage;
      console.log(index + " index");
      return list.slice(index, index + this.itemsPerPage);
    },
    getPeding() {
      this.colorLine = "error";
      this.isPaid = false;
      this.overlayF = true;
      axios
        .get(
          `https://sistema.telemontv.com:7332/api/publico/ObtenerFacturasPendientePorCedula/${this.user.identificationCard}`
        )
        .then((response) => {
          this.pedings = response.data;
          this.totalItems = this.pedings.length;
          this.overlayF = false;
          this.overlay = false;
        })
        .catch((e) => {
          error();
          this.overlayF = false;
          this.overlay = false;
        });
    },
    setPage: function(pageNumber) {
      this.currentPage = pageNumber - 1;
      console.log(pageNumber);
    },
    validateUser() {
      let self = this;
      if (this.user == null) {
        self.$router.push({
          name: "login",
        });
      }
    },

    error() {
      this.showResult = true;
      this.result = "Error Intente mas tarde";
    },
  },
};
</script>
<style scoped>
.responsive {
  height: 150px;
}
.containerC {
  background-color: white;
}
.cardtitle {
  position: relative;
  margin-left: 15%;
  top: 20px;
}
.state {
  color: green;
}
.colorCard {
  color: white;
}
.code {
  color: #0d47a1;
  font-weight: medium;
}
.codecolor {
  color: #ff9800;
}
hr {
  display: block;
  color: gray;
  border-width: 1px;
}
.number {
  color: blue;
}
.perfil {
  position: relative;
  right: 0px;
  left: 20px;
  top: 28px;
}
.vl {
  border-left: 6px solid gray;
  height: 50px;
  position: absolute;
  left: 50%;
  margin-left: -3px;
  top: 0;
}
.v {
  border-left: 10px;
  height: 100%;
  width: 2%;
  position: absolute;
  left: 0%;
}
.buttonf {
  border: 0px solid;
  outline: none;
}
/* .buttonf:active {
  color: red;
}
.buttonf:visited {
  color: purple;
} */
/* .buttonf:focus {
  -webkit-box-shadow: inset 2px 20px 141px -1px rgba(0, 0, 0, 1);
  -moz-box-shadow: inset 2px 20px 141px -1px rgba(0, 0, 0, 1);
  box-shadow: inset 2px 20px 141px -1px rgba(0, 0, 0, 1);
} */
</style>
